import Colors from '@/constants/Colors';
import styled from 'styled-components';
import { classicFonts } from '../GameActivity/gameFonts.styled';

export const StyledStoryWithQuestionsActivity = styled.div`
  ${classicFonts}
  width: 100%;
  height: 100%;
  color: ${Colors.text};
  position: relative;
  border-radius: 5px;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    max-height: 100%;
    height: 0;
  }

  .controls {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .page-counter {
      font-size: 15px;
      color: white;
      margin-left: 5px;
      font-weight: bold;
    }
  }

  &.fullscreen {
    border-radius: 0;

    .controls .page-counter {
      font-size: 20px;
    }
  }
`;
